if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.select = this.querySelector('select');
      this.disclosureButton = this.querySelector('.localization-form__select.disclosure__button');
      this.disclosureList = this.disclosureButton
        ? document.getElementById(this.disclosureButton.getAttribute('aria-controls'))
        : null;
      this.languageInput = this.form?.querySelector('input[name="language_code"]');
      this.languageLabel = this.querySelector('[data-current-language]');

      this.select?.addEventListener('change', () => this.submitForm());

      this.querySelectorAll('a[data-value]').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();

          if (link.hasAttribute('data-language-root')) {
            const localizedUrl = this.buildLocalizedUrl(link);
            if (localizedUrl) {
              window.location.assign(localizedUrl);
              return;
            }
          }

          this.updateLocalizationValue(link.dataset.value);
          this.submitForm();
        });
      });

      this.disclosureButton?.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.closest('.menu-drawer__localization')) {
          this.disclosureButton.focus({ preventScroll: true });
        }
        this.toggleDisclosure();
      });

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) {
          this.closeDisclosure();
        }
      });

      document.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') {
          this.closeDisclosure();
        }
      });

      this.syncLanguageFromUrl();
      window.addEventListener('pageshow', () => this.syncLanguageFromUrl());
    }

    getActiveLanguageLink(languageLinks, pathname) {
      const pathLanguageCode = pathname.split('/').filter(Boolean)[0]?.toLowerCase();

      return (
        languageLinks.find((link) => {
          const languageRoot = (link.dataset.languageRoot || '/').replace(/\/+$/, '') || '/';
          return languageRoot !== '/' && (pathname === languageRoot || pathname.startsWith(`${languageRoot}/`));
        }) ||
        languageLinks.find((link) => this.getLanguageCode(link).toLowerCase() === pathLanguageCode) ||
        languageLinks.find((link) => link.dataset.languagePrimary === 'true')
      );
    }

    getLanguageCode(languageLink) {
      return languageLink.getAttribute('lang') || languageLink.dataset.value;
    }

    buildLocalizedUrl(targetLanguage) {
      const languageLinks = Array.from(this.querySelectorAll('[data-language-root][data-value]'));
      if (!languageLinks.length) return null;

      const pathname = window.location.pathname.replace(/\/+$/, '') || '/';
      const activeLanguage = this.getActiveLanguageLink(languageLinks, pathname);
      const activeRoot = (activeLanguage?.dataset.languageRoot || '/').replace(/\/+$/, '') || '/';
      const targetRoot = (targetLanguage.dataset.languageRoot || '/').replace(/\/+$/, '') || '/';
      let relativePath = pathname;

      if (activeRoot !== '/' && (pathname === activeRoot || pathname.startsWith(`${activeRoot}/`))) {
        relativePath = pathname.slice(activeRoot.length) || '/';
      }

      const localizedPath = targetRoot === '/'
        ? relativePath
        : `${targetRoot}${relativePath === '/' ? '' : relativePath}`;

      return `${localizedPath}${window.location.search}${window.location.hash}`;
    }

    syncLanguageFromUrl() {
      if (!this.languageInput || !this.languageLabel) return;

      const languageLinks = Array.from(this.querySelectorAll('[data-language-root][data-value]'));
      if (!languageLinks.length) return;

      const pathname = window.location.pathname.replace(/\/+$/, '') || '/';
      const activeLanguage = this.getActiveLanguageLink(languageLinks, pathname);

      if (!activeLanguage) return;

      const activeLanguageCode = this.getLanguageCode(activeLanguage);
      this.languageInput.value = activeLanguageCode;
      this.languageLabel.textContent = activeLanguageCode.toUpperCase();
      this.disclosureButton?.setAttribute(
        'aria-label',
        `${this.dataset.languageLabel}: ${activeLanguage.dataset.languageName}`
      );

      languageLinks.forEach((link) => {
        link.closest('li')?.toggleAttribute('hidden', this.getLanguageCode(link) === activeLanguageCode);
        link.href = this.buildLocalizedUrl(link);
      });
    }

    updateLocalizationValue(value) {
      const input = this.form?.querySelector(
        'input[name="country_code"], input[name="language_code"], input[name="locale_code"]'
      );
      if (input && value) input.value = value;
    }

    submitForm() {
      if (!this.form) return;
      this.form.submit();
    }

    toggleDisclosure() {
      if (!this.disclosureButton || !this.disclosureList) return;

      const isOpen = this.disclosureButton.getAttribute('aria-expanded') === 'true';
      this.disclosureButton.setAttribute('aria-expanded', String(!isOpen));
      this.disclosureList.hidden = isOpen;
    }

    closeDisclosure() {
      if (!this.disclosureButton || !this.disclosureList) return;

      this.disclosureButton.setAttribute('aria-expanded', 'false');
      this.disclosureList.hidden = true;
    }
  }

  customElements.define('localization-form', LocalizationForm);
}

function updateBreadcrumbOffset() {
  const bc = document.querySelector('.breadcrumbs-wrapper');
  if (!bc) return;
  const h = bc.getBoundingClientRect().height;
  document.documentElement.style.setProperty('--breadcrumbs-height', `${h}px`);
}

updateBreadcrumbOffset();

if ('ResizeObserver' in window) {
  new ResizeObserver(updateBreadcrumbOffset).observe(
    document.querySelector('.breadcrumbs-wrapper') || document.body
  );
}

document.addEventListener('shopify:section:load', updateBreadcrumbOffset);
